module.exports = __webpack_public_path__ + "img/2014-3.970e71a8.jpg";